import { render, staticRenderFns } from "./ApprovalGroupSidebar.vue?vue&type=template&id=ed36a04e&"
import script from "./ApprovalGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./ApprovalGroupSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed36a04e')) {
      api.createRecord('ed36a04e', component.options)
    } else {
      api.reload('ed36a04e', component.options)
    }
    module.hot.accept("./ApprovalGroupSidebar.vue?vue&type=template&id=ed36a04e&", function () {
      api.rerender('ed36a04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/approval-group/components/ApprovalGroupSidebar.vue"
export default component.exports